import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
	changeLocation,
	changeProductgroup,
	changeSupplier,
} from "../../services/currentInformation/actions.js";
import {
	confirmSignUpAPI,
	loginAPI,
	loginWithKey,
	signUpAPI,
} from "../../services/login/actions";
import "./SignUpForm.scss";

function ConfirmSignUpForm(props) {
	const [phonenumber, setPhonenumber] = useState("");
	const [key, setKey] = useState("");
	const [code, setCode] = useState("");
	const [message, setMessage] = useState("");
	const [combinedSignupInfo, setCombinedSignupInfo] = useState({});
	const [signupCode, setSignupCode] = useState(props.identifyInfo.signup_code);

	const location = useLocation();
	let history = useHistory();

	useEffect(() => {
		if (location.state) {
			setPhonenumber(location.state.phonenumber);
			setKey(location.state.key);
			setMessage(location.state.message);
			setCombinedSignupInfo(location.state.combinedInfo);
		}
	}, [location]);

	const handleSubmitConfirm = (event) => {
		event.preventDefault();
		props.confirmSignUpAPI(key, code).then(() => {
			history.push({ pathname: "/login", state: { bottomNavBar: true } });
		});
	};

	const handleResendVerificationCode = () => {
		const {
			firstname,
			lastname,
			adres,
			zipcode,
			city,
			phonenumber,
			email,
			signupCode,
			verficationViaSMS,
		} = combinedSignupInfo || {};

		props
			.signUpAPI(
				firstname,
				lastname,
				adres,
				zipcode,
				city,
				phonenumber,
				email,
				signupCode,
				verficationViaSMS
			)
			.then((res) => {
				if (res === 404) {
					history.push({ pathname: "/signup", state: { bottomNavBar: true } });
					window.location.reload(false);
				}
				setMessage("Er is nog een verificatiecode gestuurd!");
			});
	};

	const getCorrectLogo = () => {
		if (props.logo == undefined) {
			return props.identifyInfo.logo;
		} else {
			return props.logo;
		}
	};

	return (
		<div className="LoginFormWrapper">
			<div className="LoginFormBackground"></div>
			<div className="LoginForm fadeIn">
				<div>
					<img src={getCorrectLogo()}></img>
				</div>
				<form onSubmit={handleSubmitConfirm}>
					<p>{message}</p>
					<input
						className="LoginFormInput"
						type="name"
						placeholder="Verficatiecode"
						onChange={(e) => setCode(e.target.value)}
						required
						autoFocus
					/>
					<input
						className="LoginFormSubmit"
						type="submit"
						value="Bevestig code"
					/>
				</form>
				<p
					style={{ textDecoration: "underline" }}
					onClick={() => handleResendVerificationCode()}
				>
					Code niet ontvangen? Stuur mij de code opnieuw
				</p>
			</div>
		</div>
	);
}
//}

function mapStateToProps(state) {
	return {
		loginSuccesful: state.login.data.loginSuccesful,
		userId: state.login.data.user_id,
		currentLocation: state.login.data.current_location,
		suppliers: state.assortiment.suppliers,
		currentSupplier: state.currentInformation.current_supplier,
		signupInfo: state.login.signupInfo,
		identifyInfo: state.identify.identifyInfo,
		logo: state.login.data.logo,
	};
}

export default connect(mapStateToProps, {
	confirmSignUpAPI,
	signUpAPI,
	loginAPI,
	loginWithKey,
	changeSupplier,
	changeProductgroup,
	changeLocation,
})(ConfirmSignUpForm);
